/*
 * @Description: 支付单历史相关接口
 */

import {
  PaymentAcceptanceHistoryModel,
  PaymentAcceptanceHistoryParamModel,
  PaymentAcceptanceStatementModel,
  PaymentAcceptanceStatementParamModel,
  PaymentSlipHistoryModel, RelatedPaymentSlipPageParamModel
} from '@/model/paymentSlip/paymentSlipHistoryModel'
import https, { downloadFile } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { ContentType, Method } from 'axios-mapper'
import { PaymentSlipPageModel } from '@/model/paymentSlip/paymentSlipModel'

const basePaymentSlipHistoryUrl = '/base/payment/slip/history'
const basePaymentAcceptance = '/base/payment/acceptance'

export const getPaymentSlipHistoryCashDetail = (id: string) => {
  return https().request<RootObject<PaymentSlipHistoryModel>>(basePaymentSlipHistoryUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getPaymentAcceptanceHistory = (params: PaymentAcceptanceHistoryParamModel) => {
  return https().request<RootObject<PaymentAcceptanceHistoryModel[]>>(basePaymentAcceptance + '/history/list', Method.POST, params, ContentType.json)
}

export const getPaymentAcceptanceStatement = (params: PaymentAcceptanceStatementParamModel) => {
  return https().request<RootObject<PaymentAcceptanceStatementModel[]>>(basePaymentAcceptance + '/statement/list', Method.POST, params, ContentType.json)
}

export const exportVoucherTemplate = (params: FormData) => {
  return downloadFile(basePaymentSlipHistoryUrl + '/export/fileTemplate', Method.POST, params)
}

export const exportVoucherBatchTemplate = (params: FormData) => {
  return downloadFile(basePaymentSlipHistoryUrl + '/export/batch', Method.POST, params)
}

export const getRelatedPaymentSlipPageList = (params: RelatedPaymentSlipPageParamModel) => {
  return https().request<RootObject<PaymentSlipPageModel>>(basePaymentSlipHistoryUrl + '/get/relatedPaymentSlip', Method.POST, params, ContentType.json)
}
